'use strict';

var React = require('react'),
    _ = require('underscore'),
    cloneWithProps = require('react/lib/cloneWithProps'),
    ClassNameMixin = require('../mixins/ClassNameMixin'),
    mapKeys = require('../utils/mapKeys'),
    shouldHandleClick = require('../utils/shouldHandleClick'),
    formatCount = require('../utils/formatCount'),
    PureRenderMixin = require('../mixins/PureRenderMixin');

require('./Button.less');

function validateOnClick(props, propName) {
  if (props.href || props.disabled) {
    return;
  }

  if (typeof props[propName] !== 'function') {
    console.warn('With empty href and disabled=false, expected onClick to be specified and to be a function.');
  }
}

var Button = React.createClass({
  mixins: [ClassNameMixin, PureRenderMixin],

  className: 'Btn',

  propTypes: {
    onClick: validateOnClick,
    href: React.PropTypes.string,
    color: React.PropTypes.oneOf([
      'black', 'light', 'dark', 'gray',
      'green', 'red', 'yellow',
      'facebook', 'twitter', 'google', 'pinterest', 'tubmlr', 'email',
    ]).isRequired,
    size: React.PropTypes.oneOf([
      'xsmall', 'small', 'medium', 'large', 'xlarge', 'xxlarge', 'xxxlarge'
    ]).isRequired,
    active: React.PropTypes.bool.isRequired,
    disabled: React.PropTypes.bool.isRequired,
    dataSet: React.PropTypes.object.isRequired,
    switch: React.PropTypes.bool,
    like: React.PropTypes.bool,
    follow: React.PropTypes.bool,
    round: React.PropTypes.bool,
    split: React.PropTypes.bool,
    fill: React.PropTypes.bool,
    overlay: React.PropTypes.bool,
    counter: React.PropTypes.number
  },

  getDefaultProps() {
    return {
      disabled: false,
      active: false,
      color: 'dark',
      dataSet: {},
      size: 'medium'
    };
  },

  getCSSModifiers() {
    return [
      this.props.color,
      this.props.size,
      this.props.switch && 'switch',
      this.props.like && 'like',
      this.props.follow && 'follow',
      this.props.round && 'round',
      this.props.split && 'split',
      this.props.fill && 'fill',
      this.props.overlay && 'overlay'
    ];
  },

  getDefaultContent() {
    if (this.props.switch) {
      return <i />;
    }
  },

  render() {
    var dataSet,
        dataProps;

    dataSet = _.extend({}, this.props.dataSet, {
      disabled: this.props.disabled,
      active: this.props.active
    });

    dataProps = mapKeys(dataSet, function (key) {
      return 'data-' + key;
    });

    return cloneWithProps(
      <a className={this.getClassName()}
         href={this.props.href}
         onClick={this.handleClick}
         {...this.props.params}>

        {this.props.children || this.getDefaultContent()}
        {this.renderCounter()}
      </a>,
      dataProps
    );
  },

  renderCounter() {
    if (typeof this.props.counter === 'number') {
      return (
        <span className='Btn-counter'>
          {formatCount(this.props.counter)}
        </span>
      );
    }
  },

  handleClick(e) {
    if (!this.props.onClick) {
      return;
    }

    e.stopPropagation();

    if (!this.props.href || shouldHandleClick(e)) {
      e.preventDefault();
      this.props.onClick(e);
    }
  }
});

module.exports = Button;



/** WEBPACK FOOTER **
 ** ./atoms/Button.jsx
 **/